import React, { useState, useEffect } from "react";
import "./SMMcard.css";

interface SMMCardProps {
  type: "image" | "video";
  src: string;
  poster?: string;
  client: string;
  label?: string;
}

const SMMCard: React.FC<SMMCardProps> = ({
  type,
  src,
  poster,
  client,
  label = "Ad promoțional pentru Social Media",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  
  useEffect(() => {
	if (isModalOpen) {
	  document.body.classList.add("video-playing");
	} else {
	  document.body.classList.remove("video-playing");
	}
  }, [isModalOpen]);
  

  return (
	<>
	  <div className="smm-card-wrapper" onClick={() => setIsModalOpen(true)}>
		<div className="smm-card-header">
		  <span className="smm-card-client">{client}</span>
		  <button className="smm-card-expand">⤢</button>
		</div>

		<div className="smm-card-media">
		  {type === "image" ? (
			<img src={src} alt={label} />
		  ) : (
			<div className="video-wrapper" onClick={() => setIsModalOpen(true)}>
			  <img src={poster} alt={label} className="video-thumb" />
			  <div className="video-overlay">
				<img src="/icons/custom-play.webp" alt="Play" className="play-icon" />
			  </div>
			</div>
		  )}
		  
		</div>

		<div className="smm-card-label">{label}</div>
	  </div>

	  {isModalOpen && (
		<div className="smm-modal" onClick={() => setIsModalOpen(false)}>
		  <div className="smm-modal-content" onClick={(e) => e.stopPropagation()}>
			<button className="smm-modal-close" onClick={() => setIsModalOpen(false)}>×</button>
			{type === "image" ? (
			  <img src={src} alt={label} className="smm-modal-media" />
			) : (
			<video
			  src={src}
			  poster={poster}
			  autoPlay
/*			  muted
*/			  loop
			  playsInline
			  preload="auto"
			  className="smm-modal-media"
			  onLoadedMetadata={(e) => e.currentTarget.play()}
			/>
			)}
		  </div>
		</div>
	  )}
	</>
  );
};

export default SMMCard;